// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"79":"5e593f58","142":"5a66436a","329":"5618e7d7","364":"7812c17e","493":"3b20b923","856":"ac641365","878":"2f5a6d53"}[chunkId] + ".css";
};